import { Form } from 'antd';

import { CustomInputNumber } from '@app/components';

import type { FormInstance } from 'antd';

const { Item } = Form;

interface Props {
  fieldName: number;
  form: FormInstance;
}

export const ProductCountInput = ({ fieldName, form }: Props) => (
  <Item
    name={[fieldName, 'Count']}
    labelCol={{ span: 0 }}
    wrapperCol={{ span: 24 }}
    rules={[
      { required: true, message: 'Введите количество' },
      { type: 'number', min: 1, message: 'Минимум 1', transform: Number },
    ]}
  >
    <CustomInputNumber
      className="required-field"
      allowDecimal={false}
      inputValue={form.getFieldValue(['Products', fieldName, 'Count'])}
      isAllowed={(floatValue: number) => floatValue >= 1}
      onSuccess={({ value }) => {
        if (value == null) {
          form.setFieldValue(['Products', fieldName, 'Count'], undefined);
          return;
        }
        const num = Number(String(value).replace(/\s+/g, ''));
        if (Number.isNaN(num) || num < 1) return;
        form.setFieldValue(['Products', fieldName, 'Count'], num);
      }}
    />
  </Item>
);
